import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Check, Loader2, CreditCard } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export default function AttirePayPage() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const sid = params.get("session_id");
  useEffect(() => {
    let tries = 0;
    async function load() {
      try {
        const { data } = await api.get(`/public/attire/${token}`);
        if (sid && data.status === "unpaid" && tries < 8) {
          tries += 1;
          const st = await api.get(`/public/attire/${token}/status`, { params: { session_id: sid } }).catch(() => ({ data: { status: "unpaid" } }));
          if (st.data.status === "unpaid" && st.data.known_session !== false) { setD({ ...data, checking: true }); setTimeout(load, 2500); return; }
          data.status = st.data.status;
        }
        setD(data);
      } catch (e) { setErr(formatApiError(e)); }
    }
    load();
  }, [token, sid]);
  async function pay() {
    setBusy(true);
    try { const { data } = await api.post(`/public/attire/${token}/checkout`, { origin_url: window.location.origin }); window.location.href = data.url; }
    catch (e) { toast.error(formatApiError(e)); setBusy(false); }
  }
  if (err) return <div className="min-h-screen flex items-center justify-center p-8 text-center font-serif text-2xl" data-testid="attire-pay-error">{err}</div>;
  if (!d) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-[var(--gold)]" /></div>;
  const paid = d.status !== "unpaid";
  return (
    <div className="min-h-screen bg-[var(--bg-warm)] py-12 px-5" data-testid="attire-pay-page">
      <div className="max-w-md mx-auto bg-white rounded-3xl p-7 border border-[var(--line)] space-y-4 text-center">
        <p className="font-script text-4xl text-[var(--gold)]">{d.couple_names}</p>
        <h1 className="font-serif text-3xl font-light">Hi {d.name.split(" ")[0]}</h1>
        <p className="text-[var(--muted)] text-sm">Your {d.title}{d.due_date ? `, due ${d.due_date}` : ""}</p>
        <p className="font-serif text-5xl" data-testid="attire-amount">${Number(d.amount).toFixed(2)}</p>
        {d.note && <p className="text-sm bg-[var(--bg-warm)] rounded-xl p-3 text-left">{d.note}</p>}
        {paid ? (
          <div className="py-4 space-y-2" data-testid="attire-paid"><Check className="w-10 h-10 mx-auto text-[var(--gold)]" /><p className="font-serif text-2xl">Paid. Thank you!</p></div>
        ) : d.checking ? (
          <p className="text-sm text-[var(--muted)] flex items-center justify-center gap-2" data-testid="attire-checking"><Loader2 className="w-4 h-4 animate-spin" /> Confirming your payment…</p>
        ) : (
          <button onClick={pay} disabled={busy} className="btn-gold w-full !py-3 flex items-center justify-center gap-2" data-testid="attire-pay-btn"><CreditCard className="w-4 h-4" /> {busy ? "Opening secure checkout…" : "Pay by card"}</button>
        )}
        <p className="text-[11px] text-[var(--muted)]">Payments are processed securely by Stripe for Locked In Forever.</p>
      </div>
    </div>
  );
}
